import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { outcomes } from '../data/content';
import { SectionLabel } from './ui/SectionLabel';
import { Reveal } from './ui/Reveal';
export function Outcomes() {
  return <section className="bg-cream px-4 pb-14 sm:px-5 sm:pb-24" data-id="element-143" data-mp="1m9umchywh096">
      <div className="mx-auto max-w-6xl" data-id="element-144" data-mp="1r7w5t408n1l6">
        <Reveal data-id="element-145" data-mp="1r6l0v0v23nsh">
          <SectionLabel data-id="element-146" data-mp="1r74i0fcvu85g">Cosa sviluppano mentre costruiscono</SectionLabel>
          <h2 className="display mx-auto mt-5 max-w-[26ch] text-center text-[1.7rem] text-ink sm:text-[3.1rem]" data-id="element-147" data-mp="tl6to1btn8ll">
            Meno consumo passivo.{' '}
            <span className="text-orange" data-id="element-148" data-mp="13ibjcb4vlm75">
              Più pensiero, test e creazione.
            </span>
          </h2>
        </Reveal>

        <ul className="mx-auto mt-9 grid max-w-5xl gap-3.5 sm:mt-12 sm:gap-4 md:grid-cols-2" data-id="element-149" data-mp="18a3bgq3ojzze">
          {outcomes.map((outcome, index) => <Reveal key={outcome.title} delay={index * 0.04} data-id="element-150" data-mp="ate0a5subldc" data-mpi={index}>
              <li className="h-full rounded-2xl border-2 border-ink/10 bg-white p-5 sm:p-7" data-id="element-151" data-mp="frz0w6c0872b">
                <h3 className="flex items-start gap-3 text-base font-black leading-snug text-ink sm:text-lg" data-id="element-152" data-mp="32xrgjc1ewrx2">
                  <ArrowRightIcon className="mt-1 h-4 w-4 shrink-0 text-orange" strokeWidth={3.5} aria-hidden="true" data-id="element-153" data-mp="2xzg5wz3amdds" />
                  {outcome.title}
                </h3>
                <p className="mt-2 pl-[28px] text-[15px] font-semibold leading-relaxed text-ink/65 sm:mt-2.5 sm:text-base" data-id="element-154" data-mp="2p6cusxg4ecmb">
                  {outcome.description}
                </p>
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}